import { TNumberCountry } from "@/redux/slices/numbers/types";

export const countries: TNumberCountry[] = [
  {
    name: "UK (+44)",
    key: "UK",
    value: "77",
    countryCode: "44",
    href: "/uk/",
    defaultArea: "020",
  },
  {
    name: "United States (+1)",
    key: "US",
    value: "233",
    countryCode: "1",
    href: "/united-states/",
    defaultArea: "917",
  },
  {
    name: "Canada (+1)",
    key: "CA",
    value: "38",
    countryCode: "1",
    href: "/canada/",
    defaultArea: "437",
  },
  {
    name: "France (+33)",
    key: "FR",
    value: "75",
    countryCode: "33",
    href: "/france/",
    defaultArea: "170",
  },
  {
    name: "Germany (+49)",
    key: "DE",
    value: "57",
    countryCode: "49",
    href: "/germany/",
    defaultArea: "030",
  },
  {
    name: "Ireland (+353)",
    key: "IE",
    value: "102",
    countryCode: "353",
    href: "/ireland/",
    defaultArea: "01",
  },
  {
    name: "Italy (+39)",
    key: "IT",
    value: "110",
    countryCode: "39",
    href: "/italy/",
    defaultArea: "06",
  },
  {
    name: "Spain (+34)",
    key: "ES",
    value: "68",
    countryCode: "34",
    href: "/spain/",
    defaultArea: "919",
  },
];
